<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" color="primary">
      <div class="d-flex justify-center">
        <inline-svg
          v-for="i in 2"
          :key="i"
          width="20"
          :src="require('@/assets/svg/star_white.svg')"
        />
      </div>
      Submit Feedback
    </SecondaryButton>
    <SubmitFeedbackDialog
      v-if="isDialogOpen"
      :isOpen="isDialogOpen"
      @close="closeDialog"
    />
  </BaseAction>
</template>

<script>
import SubmitFeedbackDialog from "@/views/interviews/dialogs/SubmitFeedback/SubmitFeedbackDialog";
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import InlineSvg from "vue-inline-svg";

export default {
  name: "SubmitFeedbackAction",
  components: {
    BaseAction,
    SecondaryButton,
    SubmitFeedbackDialog,
    InlineSvg
  },
  mounted() {
    if (this.shouldSubmitFeedBack) {
      this.openDialog();
    }
  },
  data() {
    return {
      isDialogOpen: false
    };
  },
  computed: {
    shouldSubmitFeedBack() {
      return Boolean(this.$route.query.shouldSubmitFeedBack);
    }
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>
